var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-article-data',{staticClass:"product-faqs",attrs:{"wrapper":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._t("title")]},proxy:true}],null,true)},[_c('c-accordion',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }